import useCachedList from './CachedList';
import ProcedureDTO from '@src/adapters/dto/procedure/ProcedureDTO';
import useAuthorisedHospitalsLazy from '@src/adapters/hooks/hospital/useAuthorisedHospitals';

const AuthorisedHospitalList = () => {
  return useCachedList<ProcedureDTO>(
    'hospitalList',
    useAuthorisedHospitalsLazy
  );
};

export default AuthorisedHospitalList;
